import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as NotFoundImage } from '@icons/images/not-found.svg';

const ZafClientFailed: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" flexGrow={1} p={6}>
      <Box alignItems="center" display="flex" justifyContent="center">
        <Typography textAlign="center" variant="subtitle1">
          Zendesk SDK Client initialization failed. Please reload the page or
          apps section
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" mt={6}>
        <NotFoundImage />
      </Box>
    </Box>
  );
};

export default ZafClientFailed;
